'use client'
import { SbBlokData, storyblokEditable } from '@storyblok/react/rsc'
import { FC, useEffect, useState } from 'react'

import { stylePanelSBData } from '@/lib/stylePanel'

import { PhnxImageslider } from './Imageslider'
import { ImagesliderProps } from './Imageslider'

interface ImagesliderBlokProps {
  blok: {
    title: ImagesliderProps['title']
    description: ImagesliderProps['description']
    autoplay: ImagesliderProps['autoplay']
    autoplayDelay: ImagesliderProps['autoplayDelay']
    alignment: SbBlokData[]
    items: SbBlokData[]
    background?: SbBlokData[]
    colour?: SbBlokData[]
  } & SbBlokData
}

const Imageslider: FC<ImagesliderBlokProps> = ({ blok }) => {
  let stylePanel = stylePanelSBData(blok.colour, blok.background, '', '')
  const [items, setItems] = useState<ImagesliderProps['items']>([])
  const [alignment, setAlignment] = useState<'left' | 'center' | 'right'>('center')

  useEffect(() => {
    // Parse alignment
    if (blok.alignment && blok.alignment.length > 0 && blok.alignment[0]?.alignment) {
      setAlignment(blok.alignment[0].alignment as 'left' | 'center' | 'right')
    }

    // Parse items
    if (blok.items && blok.items.length > 0) {
      const mappedItems = blok.items.map((item: any) => ({
        title: item.title,
        description: item.description,
        image: {
          src: item.image?.filename || item.asset?.filename,
          alt: item.image?.alt || item.asset?.alt || item.title || '',
          focus: item.image?.focus || item.asset?.focus,
        },
      }))
      setItems(mappedItems)
    }
  }, [blok])

  return (
    <div {...storyblokEditable(blok)}>
      <PhnxImageslider
        title={blok.title}
        description={blok.description}
        autoplay={blok.autoplay}
        autoplayDelay={blok.autoplayDelay}
        alignment={alignment}
        items={items}
        {...stylePanel}
      />
    </div>
  )
}

export default Imageslider
